import { publicApi } from '@shared/api/axios-instance';

export const logoutRequest = async (refreshToken: string) => {
  await publicApi.post('/api/auth/logout', null, {
    headers: {
      Authorization: `Bearer ${refreshToken}`,
    },
  });
};
